import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@backslashbuild/pp-ui";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";
import NewConsultantForm from "../modules/agencies/NewConsultantForm";

export default function CreateAgencyContact() {
  const { agencyId } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Add Consultant</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <NewConsultantForm agencyId={agencyId} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
